import { jsxs as o, Fragment as H, jsx as t } from "react/jsx-runtime";
import { useRef as S } from "react";
import { attributes as N } from "../utils/attributes.js";
import { UploadFile as j } from "./UploadFile.js";
import { useUploadStategy as D } from "./useUploadStrategy.js";
import { classnames as I } from "../utils/classnames.js";
import { ButtonIcon as P } from "../ButtonIcon/ButtonIcon.js";
import { SimpleText as d } from "../SimpleText/SimpleText.js";
import { c as f } from "../../createLucideIcon-BC8wu-bu.js";
import '../../assets/Upload.css';/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const T = f("FileStack", [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
]);
/**
 * @license lucide-react v0.441.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const z = f("Upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
function A({
  onMouseEnter: u,
  onMouseLeave: m,
  onClick: n,
  onFileChange: i,
  multiple: e = !0,
  editable: h = !0,
  onDeleteItem: s,
  onSuccess: v,
  codexData: y,
  successMessage: g = "File uploaded successfully"
  // useWorker = !!window.Worker,
}) {
  const { deleteFile: x, files: k, uploadFiles: p, warning: l } = D(
    e ? "multiple" : "single",
    h
  ), a = S(null), c = (r) => {
    r.stopPropagation(), r.preventDefault();
  }, b = (r) => {
    c(r), p(r.dataTransfer.files);
  }, U = (r) => {
    r.target.files && p(r.target.files), a.current && (a.current.value = ""), i == null || i(r);
  }, w = (r) => {
    x(r), s == null || s(r);
  }, M = () => {
    var r;
    n == null || n(), (r = a.current) == null || r.click();
  };
  return /* @__PURE__ */ o(H, { children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: I(["upload"], ["upload-warning", !!l]),
        tabIndex: 1,
        onClick: M,
        onDragOver: c,
        onDragEnter: c,
        onDrop: b,
        onMouseEnter: u,
        onMouseLeave: m,
        children: [
          /* @__PURE__ */ t(P, { Icon: e ? T : z }),
          /* @__PURE__ */ o("div", { className: "upload-text", children: [
            /* @__PURE__ */ t("div", { children: /* @__PURE__ */ o("b", { children: [
              "Drop your ",
              e ? "file(s)" : "file",
              " here or",
              " ",
              /* @__PURE__ */ t("span", { className: "text--primary", children: "browse" })
            ] }) }),
            /* @__PURE__ */ t(d, { size: "small", variant: "light", center: !0, children: e ? "Up to 10 files" : "Choose one single file" })
          ] }),
          /* @__PURE__ */ t(
            "input",
            {
              "data-testid": "upload",
              type: "file",
              hidden: !0,
              ref: a,
              onChange: U,
              ...N({ multiple: e })
            }
          ),
          l && /* @__PURE__ */ t(d, { variant: "warning", children: l })
        ]
      }
    ),
    k.map(({ id: r, file: F }) => /* @__PURE__ */ t(
      j,
      {
        file: F,
        onClose: () => w(r),
        id: r,
        onSuccess: v,
        codexData: y,
        successMessage: g
      },
      r
    ))
  ] });
}
export {
  A as Upload
};
//# sourceMappingURL=Upload.js.map
